import { Button, Card, CardButtonActionMode, HeaderGradient, MiniCard, Row } from '@app/components';
import React, { memo } from 'react';
import { theme } from '@app/theme';
import { useDynamicSizes } from '@app/hooks';
import LinearGradient from 'react-native-linear-gradient';
import { StyleSheet } from 'react-native';
import { CONNECTOR_TYPE_LABELS, IConnector } from '@app/common';
import { triptychSelectors } from '@app/store';
import { useAppSelector } from '@app/store/hooks';
import { UseFormReturn, useWatch } from 'react-hook-form';

type ConnectorCardProps = {
  connector?: Partial<IConnector>;
  toggle: (mode: CardButtonActionMode) => void;
  formMethods: UseFormReturn<any, any, any>;
};

export const ConnectorCard = memo(({ formMethods, toggle, connector }: ConnectorCardProps) => {
  const { subContainerHeight } = useDynamicSizes();

  const cardData = useWatch({
    control: formMethods.control,
  });

  const isOpen = useAppSelector(triptychSelectors.selectIsOpen);

  return (
    <Card>

      <HeaderGradient>
        <LinearGradient
          start={{ x: 0.5, y: 0 }}
          end={{ x: 0.5, y: 1 }}
          locations={[0, 1]}
          colors={['rgba(253, 255, 252, 0)', 'rgba(253, 255, 252, 1)']}
          style={styles.headerGradient}
        />
      </HeaderGradient>

      <Card.TopHeader>
        <Card.TopHeaderLabel>Fiche connecteur</Card.TopHeaderLabel>
      </Card.TopHeader>

      <Card.Container height={subContainerHeight}>
        <Card.Background source={require('@app/assets/img/cardbackground.png')} />

        <Card.Content>
          <Card.Header>
            <Row justify="space-between" align="center">
              <Card.HeaderTitles>
                <Card.Title numberOfLines={2}>{cardData?.name}</Card.Title>
                {connector?.type && <Card.Subtitle>{CONNECTOR_TYPE_LABELS[connector.type]}</Card.Subtitle>}
                {connector?._id && <Card.Subtitle>Ref: {connector._id}</Card.Subtitle>}
              </Card.HeaderTitles>

              {isOpen && (
                <Button
                  title="Fermer"
                  bordered
                  onPress={() => toggle("CLOSE")} />
              )}
            </Row>
          </Card.Header>
        </Card.Content>

        <MiniCard>
          <MiniCard.Container />
        </MiniCard>
      </Card.Container>
    </Card>
  );
});


const styles = StyleSheet.create({
  headerGradient: {
    flex: 1,
    height: theme.sizes.listHeaderHeight,
  },
});
